import eventBus from '@/services/eventBus'
import { useState, useEffect } from 'react'
import { INotificationWsMessage } from './notifications.types'
import userAtom from '@/pages/User/user.atom'
import { useSetRecoilState } from 'recoil'
import useStateRef from '@/shared/hooks/useStateRef'

const useNotificationService = () => {
  const [active, setActive] = useState(false)
  const activeRef = useStateRef(active)

  // Состояние, указывающее были ли пропущены уведомления,
  // если на момент получения уведомления active === true,
  // значит предыдущее уведомление не было закрыто и соответсвенно не было прочитано
  const [isNotificationsMissed, setIsNotificationsMissed] = useState(false)

  const [notificationData, setNotificationData] = useState<INotificationWsMessage>()
  const setUserState = useSetRecoilState(userAtom)

  useEffect(() => {
    const unsubscribe = eventBus.sub('notification.received', (ev) => {
      if (ev.type !== 'ALARM_SITUATION_INCIDENT') {
        setIsNotificationsMissed(activeRef.current)
        setUserState((prev) => ({ ...prev, isNotificationsViewed: false }))
      }
      setNotificationData(ev)
      setActive(true)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  const handleActive = (value: boolean) => {
    // Все уведомления прочитаны если, нет пропущенных уведомлений или все уведомления прочитаны.
    // Второе возможно, если только что полученное уведомления не было закрыто, но было прочитано в NotificationCenter
    setUserState((prev) => ({ ...prev, isNotificationsViewed: !isNotificationsMissed || prev.isNotificationsViewed }))
    setActive(value)
  }

  return { notificationData, active, setActive: handleActive }
}

export default useNotificationService
